import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getAvailableInfrastructureTypes(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].getAvailableInfrastructureTypes,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getBasedInfrastructureTypes(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].getBasedInfrastructureTypes,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getExtendedInfrastructureTypes(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].getExtendedInfrastructureTypes,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getFulledInfrastructureTypes(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].getFulledInfrastructureTypes,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getInfrastructureType(companyId, infrastructureTypesId) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].getInfrastructureType,
		{
			urlParams: {
				companyId,
				infrastructureTypesId,
			},
		}
	)
}

function getInfrastructureTypesPreview(companyId, infrastructureTypesId) {
	return dataTransferWrap(ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].getInfrastructureTypesPreview, {
		urlParams: {
			companyId,
			infrastructureTypesId,
		},
	})
}

function createInfrastructureTypes(companyId, data) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].createInfrastructureTypes,
		{
			urlParams: {
				companyId,
			},
			...data,
		},
	)
}

function patchInfrastructureTypes(companyId, infrastructureTypesId, data) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].patchInfrastructureTypes,
		{
			urlParams: {
				companyId,
				infrastructureTypesId,
			},
			...data,
		},
	)
}

function putInfrastructureTypes(companyId, infrastructureTypesId, data) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].putInfrastructureTypes,
		{
			urlParams: {
				companyId,
				infrastructureTypesId,
			},
			...data,
		},
	)
}

function deleteInfrastructureTypes(companyId, infrastructureTypesId) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,dtConfig[ModulesMap.INFRASTRUCTURE_TYPES].deleteInfrastructureTypes,
		{
			urlParams: {
				companyId,
				infrastructureTypesId,
			},
		},
	)
}


export default {
	getAvailableInfrastructureTypes,
	getBasedInfrastructureTypes,
	getExtendedInfrastructureTypes,
	getFulledInfrastructureTypes,
	getInfrastructureType,
	getInfrastructureTypesPreview,
	patchInfrastructureTypes,
	putInfrastructureTypes,
	createInfrastructureTypes,
	deleteInfrastructureTypes,
}
